import React, { Component } from 'react'
import _ from 'lodash'
import { LineChart, CartesianGrid, ResponsiveContainer, Tooltip, Label, ReferenceLine, Line, XAxis, YAxis } from 'recharts'
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FatLoss from '../../../../../images/change-goal-pictures/weight-loss-2020.png'
import Maintenance from '../../../../../images/change-goal-pictures/maintenance-2020.png'
import MuscleGain from '../../../../../images/change-goal-pictures/muscle-gain-2020.png'
import ReverseDieting from '../../../../../images/change-goal-pictures/reverse-2020.png'
import '../../../../../css/widget-weight-graph.sass'
import PracticeMode from '../../../../../images/new-vacation-mode/practice-mode.png'
import PauseMode from '../../../../../images/new-vacation-mode/pause-mode.png'
import { ReactComponent as PracticeModeIcon } from '../../../../../images/new-vacation-mode/practice-mode.svg'
import { ReactComponent as GoalPauseIcon } from '../../../../../images/new-vacation-mode/pause-mode.svg'

class CustomizedDotCompliant extends Component {
  render () {
    const {cx, cy, payload} = this.props;
    if(payload.compliant)
      return (
        <svg className={"compliant-icon " + payload.Goal} x={cx - 6} y={cy - 6} width={12} height={12} fill={colorForGradient(payload.Goal, payload.vacationModeInfo)} viewBox="0 0 128 128">
          <ellipse cx="64" cy="64" rx="64" ry="64" />
        </svg>
      );
    else
      return (
        <svg className={"compliant-icon " + payload.Goal} x={cx - 6} y={cy - 6} width={12} height={12} fill={colorForGradient(payload.Goal, payload.vacationModeInfo)} viewBox="0 0 128 128">
          <ellipse cx="64" cy="64" rx="64" ry="64" />
          <ellipse fill="#ffffff" cx="64" cy="64" rx="48" ry="48" />
        </svg>
      );
  }
}

class CustomizedDot extends Component {
  getTextWidth = (text) => {
    switch (text) {
      case "FL": return '8'
      case "MG": return '4'
      case "RD": return '7'
      case "M": return '9'
      default: return '4'
    }
  }

  render () {
    const {cx, payload} = this.props;

    let text = "MG";
    let _value = payload.Goal;

    if(payload.vacationModeInfo?.practice_mode)
      text = <PracticeModeIcon />
    else if(payload.vacationModeInfo && !payload.vacationModeInfo?.practice_mode)
      text = <GoalPauseIcon />;
    else if(_value === "FAT LOSS")
      text = 'FL';
    else if(_value === "MUSCLE GAIN")
      text = 'MG';
    else if(_value === "REVERSE DIETING")
      text = 'RD';
    else if(_value === "MAINTENANCE")
      text = 'M';

    if(payload.vacationModeInfo?.practice_mode)
      return (
        <svg className={"change-goal-icon " + payload.Goal} x={cx - 16} y={10} width={32} height={32} viewBox="0 0 32 32">
          <PracticeModeIcon />
        </svg>
      );
    else if(payload.vacationModeInfo && !payload.vacationModeInfo?.practice_mode)
      return (
        <svg className={"change-goal-icon " + payload.Goal} x={cx - 16} y={10} width={32} height={32} viewBox="0 0 32 32">
          <GoalPauseIcon />
        </svg>
      );
    else if(payload.ChangedGoalTo !== 0)
      return (
        <svg className={"change-goal-icon " + payload.Goal} x={cx - 16} y={10} width={32} height={32} viewBox="0 0 32 32">
          <circle cx="16" cy="16" r="16" fill={colorForGradient(payload.Goal)} />
          <text fill='white' x={this.getTextWidth(text)} y='22' style={{'fontSize': '14px', 'textAlign': 'center'}}>{text}</text>
        </svg>
      );
    return <svg></svg>
  }
}

class CustomTooltip extends Component {
  render() {
    const { payload } = this.props;

    if(payload === null || payload.length <= 0)
      return <div></div>

    let currentPayload = payload[0].payload

    let icon = FatLoss;
    let _value = currentPayload.Goal;

    if(currentPayload?.vacationModeInfo?.practice_mode)
      icon = PracticeMode;
    else if(currentPayload?.vacationModeInfo && !currentPayload?.vacationModeInfo?.practice_mode)
      icon = PauseMode;
    else if(_value === 'FAT LOSS')
      icon = FatLoss;
    else if(_value === 'MUSCLE GAIN')
      icon = MuscleGain;
    else if(_value === 'REVERSE DIETING')
      icon = ReverseDieting;
    else if(_value === 'MAINTENANCE')
      icon = Maintenance;


    if(currentPayload.compliant) {
      return (
        <div className={'custom-tooltip'} style={{borderColor: colorForGradient(currentPayload.Goal)}}>
          <div className='date' style={{color: '#00ee46', fontWeight: 'bold'}}>In range</div>
          <img src={icon} alt={_value}/>
          {(this.props.usePercentage) ?
            <div className='value'>{Number(payload[0].value).toFixed(1) + '%'}</div>
          :
            <div className='value'>{Number(payload[0].value).toFixed(1) + ((this.props.useMetric === 0) ? ' lbs' : ' kgs')}</div>
          }
          <div className='date'>{currentPayload.name}</div>
        </div>
      )
    } else if (currentPayload?.vacationModeInfo?.practice_mode) {
      return (
        <div className={'custom-tooltip'} style={{borderColor: colorForGradient(currentPayload.Goal, currentPayload.vacationModeInfo)}}>
          <div className='date' style={{color: '#CFE92A', fontWeight: 'bold'}}>Practice mode</div>
          <img src={icon} alt={_value}/>
          {(this.props.usePercentage) ?
            <div className='value'>{Number(payload[0].value).toFixed(1) + '%'}</div>
          :
            <div className='value'>{Number(payload[0].value).toFixed(1) + ((this.props.useMetric === 0) ? ' lbs' : ' kgs')}</div>
          }
          <div className='date'>{currentPayload.name}</div>
        </div>
      )
    } else if (currentPayload?.vacationModeInfo && !currentPayload?.vacationModeInfo?.practice_mode) {
      return (
        <div className={'custom-tooltip'} style={{borderColor: colorForGradient(currentPayload.Goal, currentPayload.vacationModeInfo)}}>
          <div className='date' style={{color: '#32F6DB', fontWeight: 'bold'}}>Goal paused</div>
          <img src={icon} alt={_value}/>
          {(this.props.usePercentage) ?
            <div className='value'>{Number(payload[0].value).toFixed(1) + '%'}</div>
          :
            <div className='value'>{Number(payload[0].value).toFixed(1) + ((this.props.useMetric === 0) ? ' lbs' : ' kgs')}</div>
          }
          <div className='date'>{currentPayload.name}</div>
        </div>
      )
    } else {
      return (
        <div className={'custom-tooltip'} style={{borderColor: colorForGradient(currentPayload.Goal, currentPayload.vacationMode, currentPayload.vacationModeInfo)}}>
          <div className='date' style={{color: '#de37ff', fontWeight: 'bold'}}>Out of range</div>
          <img src={icon} alt={_value}/>
          {(this.props.usePercentage) ?
            <div className='value'>{Number(payload[0].value).toFixed(1) + '%'}</div>
          :
            <div className='value'>{Number(payload[0].value).toFixed(1) + ((this.props.useMetric === 0) ? ' lbs' : ' kgs')}</div>
          }
          <div className='date'>{currentPayload.name}</div>
        </div>
      )
    }
  }
}

const colorForGradient = (_value, vacationModeInfo) => {
  if(vacationModeInfo?.practice_mode)
    return '#CFE92A';
  else if(vacationModeInfo && !vacationModeInfo?.practice_mode)
    return '#32F6DB';
  else if(_value === 'FAT LOSS')
    return '#6928e3';
  else if(_value === 'MUSCLE GAIN')
    return '#e39428';
  else if(_value === 'REVERSE DIETING')
    return '#e328a1';
  else if(_value === 'MAINTENANCE')
    return '#e32828';
}

// const DecimalRound = (num, places) => {
//   var multiplier = Math.pow(10, places);
//   return Math.floor(num * multiplier) / multiplier;
// }

class WeightGraph extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: window.innerWidth,
      weighInsSize: 9,
      value: 'weight'
    };

    this.throttledResize = _.throttle(this.handleWindowSizeChange, 500);
  }

  componentDidMount() {
    window.addEventListener('resize', this.throttledResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.throttledResize);
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth })
  }

  getData(_value) {
    let lastGoal = 'idkman';
    let lastPracticeMode = undefined;
    let lastPauseMode = undefined;
    let data = []
    let first = true;
    let id = 0;
    const LBS_PER_KG = 2.204622
    
    if(this.props.weighins) {
      for(let i = this.state.weighInsSize; i >= 0; i--) {
        let weighin = this.props.weighins.slice(0)[i]
        if(!_.isEmpty(weighin)) {
          let goal = weighin.goal

          const reportDate = new Date(weighin.report_date)
          let weight = (weighin.edited_weight) ? weighin.edited_weight : weighin.weight;
          weight = (weighin.estimated_weight) ? weighin.estimated_weight : weight; // NOTE: If a user has an estimated weight, show that estimated weight.
          if(this.props.useMetric === 0)
            weight *= LBS_PER_KG

          let bodyfat = (weighin.edited_body_fat) ? weighin.edited_body_fat : weighin.body_fat

          if(_value)
          {
            if(_value !== goal)
            {
              bodyfat = 0
              weight = 0
            }
          }

          let goalWas = (goal !== lastGoal) ? lastGoal : 0

          if(first)
            goalWas = goal

          let dataObject = {
            'name': (reportDate.getUTCMonth()+1 + '/' + reportDate.getUTCDate()) + '/' + reportDate.getFullYear().toString().substr(-2),
            'month': reportDate.getUTCMonth()+1,
            'day': reportDate.getUTCDate(),
            'year': reportDate.getFullYear().toString().substr(-2),
            'id': id,
            'compliant': weighin.compliant,

            'w': this.round(weight, 1),
            'bf': bodyfat,
            'lbm': this.round(weight*(1-bodyfat/100), 1),

            'Goal': goal,
            'GoalWas': goalWas,
            'ChangedGoalTo': (goal !== lastGoal) ? goal : 0,
            'vacationModeInfo': weighin.vacation_mode_info,
            'currentPauseMode': weighin.vacation_mode_info && !weighin.vacation_mode_info?.practice_mode,
            'currentPracticeMode': weighin.vacation_mode_info && weighin.vacation_mode_info?.practice_mode,
            'lastPauseMode': lastPauseMode,
            'lastPracticeMode': lastPracticeMode
          }
          data.push(dataObject)
          lastGoal = goal;
          lastPracticeMode = weighin.vacation_mode_info && weighin.vacation_mode_info?.practice_mode;
          lastPauseMode = weighin.vacation_mode_info && !weighin.vacation_mode_info?.practice_mode;
          first = false;
          id++;        }
      }
    }

    // linearGradient can't render straight lines, so add a tiny variation to the weight values and round labels
    // https://stackoverflow.com/questions/21638169/svg-line-with-gradient-stroke-wont-display-if-vertical-or-horizontal/21639059
    if (data && data.length > 0) {
      for (let i = 0; i < data.length; i++) {
        if (typeof data[i].w === 'number') {
          // Add a very tiny value based on index to ensure uniqueness
          data[i].w = data[i].w + i * 1e-3;
          data[i].bf = data[i].bf + i * 1e-3;
          data[i].lbm = data[i].lbm + i * 1e-3;
        }
      }
    }

    if(!this.props.macros) {
      return data
    } else {
      for(let i = data.length -1; i >= 0; i--) {
        const findMacros = this.props.macros.find((entry) => {
          if(entry.macros) {
            const macroCreatedAt = new Date(entry.macros.created_at)
            const macroDate = (macroCreatedAt.getUTCMonth()+1 + '/' + macroCreatedAt.getUTCDate()) + '/' + macroCreatedAt.getFullYear().toString().substr(-2)
            
            if(data && (data[i].name === macroDate)) {
              return entry
            } else {
              return null
            }
          }
        else {
          return null
        }

        });

        if(findMacros) {
          const protein = Number(findMacros.macros.protein.toFixed())
          const carbs = Number(findMacros.macros.carbs.toFixed())
          const fat = Number(findMacros.macros.fat.toFixed()) 
          const calories = (4 * (carbs + protein)) + (9 * fat)

          data[i].calories = calories
        }
      }  
    }

    return data
  }

  round(value, decimals) {
    return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
  }

  handleChange = (e, value) => {
    this.setState({ value })
  }

  handleDropdown = (e) => {
    this.setState({weighInsSize: Number(e.target.value)}
  )};
    
  getLineGradient = () => {
    const data = this.getData();
    const stops = [];
    
    if (data.length > 0) {
      stops.push(
        <stop key="initial" offset={0} stopColor={colorForGradient(data[0].Goal, data[0].vacationModeInfo)} stopOpacity={1}/>
      );
    }
  
    data.forEach((info, id) => {
      let place = info.id / (data.length - 1) || 0;

      if(info.currentPauseMode) {
        if(info.lastPauseMode) {
          stops.push(
            <stop key={id + 'before'} offset={place - 0.001} stopColor={'#32F6DB'} stopOpacity={1}/>
          );
        } else if (info.lastPracticeMode) {
          stops.push(
            <stop key={id + 'before'} offset={place - 0.001} stopColor={'#CFE92A'} stopOpacity={1}/>
          );
        } else {
          stops.push(
            <stop key={id + 'before'} offset={place - 0.001} stopColor={colorForGradient(info.Goal)} stopOpacity={1}/>
          );
        }
        stops.push(
          <stop key={id + 'after'} offset={place + 0.001} stopColor={'#32F6DB'} stopOpacity={1}/>
        );
      } else if(info.currentPracticeMode) {
        if(info.lastPauseMode) {
          stops.push(
            <stop key={id + 'before'} offset={place - 0.001} stopColor={'#32F6DB'} stopOpacity={1}/>
          );
        } else if (info.lastPracticeMode) {
          stops.push(
            <stop key={id + 'before'} offset={place - 0.001} stopColor={'#CFE92A'} stopOpacity={1}/>
          );
        } else {
          stops.push(
            <stop key={id + 'before'} offset={place - 0.001} stopColor={colorForGradient(info.Goal)} stopOpacity={1}/>
          );
        }
        stops.push(
          <stop key={id + 'after'} offset={place + 0.001} stopColor={'#CFE92A'} stopOpacity={1}/>
        );
      } else if(info.ChangedGoalTo !== 0) {
        stops.push(
          <stop key={id + 'before'} offset={place - 0.001} stopColor={colorForGradient(info.GoalWas)} stopOpacity={1}/>,
          <stop key={id + 'after'} offset={place + 0.001} stopColor={colorForGradient(info.ChangedGoalTo, info.vacationModeInfo)} stopOpacity={1}/>
        );
      } else {
        if(info.lastPauseMode) {
          stops.push(
            <stop key={id + 'before'} offset={place - 0.001} stopColor={'#32F6DB'} stopOpacity={1}/>
          );
        } else if (info.lastPracticeMode) {
          stops.push(
            <stop key={id + 'before'} offset={place - 0.001} stopColor={'#CFE92A'} stopOpacity={1}/>
          );
        } else {
          stops.push(
            <stop key={id + 'before'} offset={place - 0.001} stopColor={colorForGradient(info.Goal)} stopOpacity={1}/>
          );
        }
        stops.push(
          <stop key={id + 'after'} offset={place + 0.001} stopColor={colorForGradient(info.Goal)} stopOpacity={1}/>
        )
      }
    });
    
    if (data.length > 0) {
      const lastInfo = data[data.length - 1];
      stops.push(
        <stop key="final" offset={1} stopColor={colorForGradient(lastInfo.Goal, lastInfo.vacationModeInfo)} stopOpacity={1}/>
      );
    }

    return stops;
  }

  render() {
    return (
      <div className='avn-widget'>
        <div className='weight-graph-tabs'>
          <button className={this.state.value === 'weight' ? 'weight-graph-tab active' : 'weight-graph-tab'} onClick={() => this.setState({value: 'weight'})}>
            {(this.state.width >= 600) ? 'Weight' : 'W'}
          </button>
          <button className={this.state.value === 'body-fat' ? 'weight-graph-tab active' : 'weight-graph-tab'} onClick={() => this.setState({value: 'body-fat'})}>
            {(this.state.width >= 600) ? 'Body Fat' : 'BF'}
          </button>
          <button className={this.state.value === 'lean-body-mass' ? 'weight-graph-tab active' : 'weight-graph-tab'} onClick={() => this.setState({value: 'lean-body-mass'})}>
            {(this.state.width >= 600) ? 'Lean Body Mass' : 'LBM'}
          </button>
        </div>
        {(_.size(this.props.weighins) > 5) && 
          <div className='weight-graph-dropdown'>
            <Select value={this.state.weighInsSize} disableUnderline onChange={this.handleDropdown}>
              <MenuItem style={{ fontFamily: 'DM Sans'}} value={_.size(this.props.weighins)}>All check-ins</MenuItem>
              <MenuItem style={{ fontFamily: 'DM Sans'}} value={4}>Last 5 check-ins</MenuItem>
              <MenuItem style={{ fontFamily: 'DM Sans'}} value={9}>Last 10 check-ins</MenuItem>
              <MenuItem style={{ fontFamily: 'DM Sans'}} value={14}>Last 15 check-ins</MenuItem>
              <MenuItem style={{ fontFamily: 'DM Sans'}} value={24}>Last 25 check-ins</MenuItem>
            </Select>
          </div>
        }
        {this.state.value === 'weight' &&
          <div className='weight-graph-tab-container'>
            <div>
              <ResponsiveContainer width='100%' height={312}>
                <LineChart
                  data={this.getData()}
                  margin={{ bottom: 24, left: 24, top: 60, right: 24}}
                >
                  <CartesianGrid stroke='#444444'/>
                  <XAxis type='category' tick={{ fill: '#FFFFFF', fontSize: '0.8em', dy: 8}} dataKey='name' fontFamily='DM Sans, sans-serif'/>
                  <YAxis yAxisId="left" tickFormatter={(value) => Math.round(value).toFixed(1)} tick={{ fill: '#FFFFFF', fontSize: '0.8em' }} domain={['dataMin - 1', 'dataMax + 1']}>
                    <Label fontFamily='DM Sans, sans-serif' dx={-25} angle={270} style={{fill: '#FFF'}}>{(this.props.useMetric) ? 'Kilograms' : 'Pounds'}</Label>
                  </YAxis>
                  <YAxis yAxisId="right" tick={{ fill: '#FFFFFF', fontSize: '0.8em' }} orientation="right" domain={['dataMin - 1', 'dataMax + 1']}>
                    <Label fontFamily='DM Sans, sans-serif' dx={25} angle={270} style={{fill: '#FFF'}}>Calories</Label>
                  </YAxis>
                  <Line isAnimationActive={false} yAxisId="left" type="monotone" dataKey="w" strokeWidth="4" stroke="url(#splitColor)" dot={<CustomizedDotCompliant />} />
                  <Line isAnimationActive={false} yAxisId="left" type="monotone" dataKey="w" strokeWidth="0" dot={<CustomizedDot />}/>
                  <Line isAnimationActive={false} yAxisId="right" type="monotone" dataKey="calories" strokeWidth="4" stroke="#35bcf5" />
                  <defs>
                    <linearGradient id='splitColor' x1='0' y1='0' x2='1' y2='0' opacity={1}>
                      {this.getLineGradient()}
                    </linearGradient>
                  </defs>
                  {this.getData().map((info, id) => {
                    if(info.ChangedGoalTo !== 0)
                      return (<ReferenceLine yAxisId="left" className='goal-change-line' key={id} x={info.name} strokeDasharray="3 3" stroke="#FFFFFF" />)
                    return null;
                  })}
                  <Tooltip
                    animationEasing="ease-in-out"
                    content={<CustomTooltip weighins={this.props.weighins} useMetric={this.props.useMetric} />}
                    labelStyle={{textAlign: 'left', fontSize: '1em', fontFamily: 'DM Sans, sans-serif'}}
                    itemStyle={{fontWeight: 'bold', fontSize: '0.8em', fontFamily: 'DM Sans, sans-serif'}}
                    wrapperStyle={{ cursor: false }} />
                </LineChart>
              </ResponsiveContainer>
              <div className='weight-graph-legend'>
                <div className='graph-line-container'>
                  <div>
                    <div className='legend-line general' style={{background: '#6928e3'}}></div>
                    <div className='legend-line general' style={{background: '#e39428'}}></div>
                    <div className='legend-line general' style={{background: '#e328a1'}}></div>
                    <div className='legend-line general' style={{background: '#e32828'}}></div>
                    <div className='legend-line general' style={{background: '#CFE92A'}}></div>
                    <div className='legend-line general' style={{background: '#32F6DB'}}></div>
                  </div>
                  <label>Weight</label>
                </div>
                <div className='graph-line-container'>
                  <div className='legend-line calories'></div>
                  <label>Calories</label>
                </div>
              </div>
            </div>
          </div>
        }
        {this.state.value === 'body-fat' &&
          <div className='weight-graph-tab-container'>
            <div>
              <ResponsiveContainer width='100%' height={312}>
                <LineChart
                  data={this.getData()}
                  margin={{ bottom: 24, left: 24, top: 60, right: 24}}
                >
                  <CartesianGrid stroke='#444444'/>
                  <XAxis type='category' tick={{ fill: '#FFFFFF', fontSize: '0.8em', dy: 8}} dataKey='name' fontFamily='DM Sans, sans-serif'/>
                  <YAxis yAxisId="left"  tickFormatter={(value) => `${Math.round(value).toFixed(1)}%`} tick={{ fill: '#FFFFFF', fontSize: '0.8em' }} domain={['dataMin - 1', 'dataMax + 1']}>
                    <Label style={{fill: '#FFF'}} fontFamily='DM Sans, sans-serif' dx={-25} angle={270} >Percentage</Label>
                  </YAxis>
                  <YAxis yAxisId="right" tick={{ fill: '#FFFFFF', fontSize: '0.8em' }} orientation="right" domain={['dataMin - 1', 'dataMax + 1']}>
                    <Label style={{fill: '#FFF'}} fontFamily='DM Sans, sans-serif' dx={25} angle={270}>Calories</Label>
                  </YAxis>
                  <Line isAnimationActive={false} yAxisId="left" type="monotone" dataKey="bf" strokeWidth="4" stroke="url(#splitColor)" dot={<CustomizedDotCompliant />} />
                  <Line isAnimationActive={false} yAxisId="left" type="monotone" dataKey="bf" strokeWidth="0" dot={<CustomizedDot />}/>
                  <Line isAnimationActive={false} yAxisId="right" type="monotone" dataKey="calories" strokeWidth="4" stroke="#35bcf5" />
                  <defs>
                    <linearGradient id='splitColor' x1='0' y1='0' x2='1' y2='0' opacity={1}>
                      {this.getLineGradient()}
                    </linearGradient>
                  </defs>
                  {this.getData().map((info, id) => {
                    if(info.ChangedGoalTo !== 0)
                      return (<ReferenceLine yAxisId="left" className='goal-change-line' key={id} x={info.name} strokeDasharray="3 3" stroke="#222222" />)
                    return null;
                  })}
                  <Tooltip
                    animationEasing="ease-in-out"
                    content={<CustomTooltip weighins={this.props.weighins} useMetric={this.props.useMetric} usePercentage={true} />}
                    labelStyle={{textAlign: 'left', fontSize: '1em', fontFamily: 'DM Sans, sans-serif'}}
                    itemStyle={{fontWeight: 'bold', fontSize: '0.8em', fontFamily: 'DM Sans, sans-serif'}}
                    wrapperStyle={{ cursor: false }} />
                </LineChart>
              </ResponsiveContainer>
              <div className='weight-graph-legend'>
                <div className='graph-line-container'>
                  <div className='legend-line general'></div>
                  <label>Body Fat</label>
                </div>
                <div className='graph-line-container'>
                  <div className='legend-line calories'></div>
                  <label>Calories</label>
                </div>
              </div>
            </div>
          </div>
        }
        {this.state.value === 'lean-body-mass' &&
          <div className='weight-graph-tab-container'>
            <div>
              <ResponsiveContainer width='100%' height={312}>
                <LineChart
                  data={this.getData()}
                  margin={{ bottom: 24, left: 24, top: 60, right: 24}}
                >
                  <CartesianGrid stroke='#444444'/>
                  <XAxis type='category' tick={{ fill: '#FFFFFF', fontSize: '0.8em', dy: 8}} dataKey='name' fontFamily='DM Sans, sans-serif'/>
                  <YAxis yAxisId="left" tickFormatter={(value) => Math.round(value).toFixed(1)} tick={{ fill: '#FFFFFF', fontSize: '0.8em' }} domain={['dataMin - 1', 'dataMax + 1']}>
                    <Label style={{fill: '#FFF'}} fontFamily='DM Sans, sans-serif' dx={-25} angle={270}>{(this.props.useMetric) ? 'Kilograms' : 'Pounds'}</Label>
                  </YAxis>
                  <YAxis yAxisId="right" tick={{ fill: '#FFFFFF', fontSize: '0.8em' }} orientation="right" domain={['dataMin - 1', 'dataMax + 1']}>
                    <Label style={{fill: '#FFF'}} fontFamily='DM Sans, sans-serif' dx={25} angle={270}>Calories</Label>
                  </YAxis>
                  <Line isAnimationActive={false} yAxisId="left" type="monotone" dataKey="lbm" strokeWidth="4" stroke="url(#splitColor)" dot={<CustomizedDotCompliant />} />
                  <Line isAnimationActive={false} yAxisId="left" type="monotone" dataKey="lbm" strokeWidth="0" dot={<CustomizedDot />}/>
                  <Line isAnimationActive={false} yAxisId="right" type="monotone" dataKey="calories" strokeWidth="4" stroke="#35bcf5" />

                  <defs>
                    <linearGradient id='splitColor' x1='0' y1='0' x2='1' y2='0' opacity={1}>
                      {this.getLineGradient()}
                    </linearGradient>
                  </defs>
                  {this.getData().map((info, id) => {
                    if(info.ChangedGoalTo !== 0)
                      return (<ReferenceLine yAxisId="left" className='goal-change-line' key={id} x={info.name} strokeDasharray="3 3" stroke="#222222" />)
                    return null;
                  })}
                  <Tooltip
                    animationEasing="ease-in-out"
                    content={<CustomTooltip weighins={this.props.weighins} useMetric={this.props.useMetric} />}
                    labelStyle={{textAlign: 'left', fontSize: '1em', fontFamily: 'DM Sans, sans-serif'}}
                    itemStyle={{fontWeight: 'bold', fontSize: '0.8em', fontFamily: 'DM Sans, sans-serif'}}
                    wrapperStyle={{ cursor: false }} />
                </LineChart>
              </ResponsiveContainer>
              <div className='weight-graph-legend'>
                <div className='graph-line-container'>
                  <div className='legend-line general'></div>
                  <label>LBM</label>
                </div>
                <div className='graph-line-container'>
                  <div className='legend-line calories'></div>
                  <label>Calories</label>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    )
  }
}

export default WeightGraph
